module.exports = __webpack_public_path__ + "static/media/17.f45920b2.jpg";